var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06936 1.47725C9.48299 1.06362 10.044 0.83125 10.629 0.83125H16.9632C18.1813 0.83125 19.1688 1.81873 19.1688 3.03684V9.37105C19.1688 9.95601 18.9364 10.517 18.5227 10.9306L10.9306 18.5227C10.0693 19.3841 8.6728 19.3841 7.81146 18.5227L1.47725 12.1885C0.615915 11.3272 0.615916 9.9307 1.47725 9.06936L9.06936 1.47725Z",
    stroke: "currentColor",
    strokeWidth: 1.6625
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2891,
    cy: 5.71436,
    r: 1.66875,
    stroke: "currentColor",
    strokeWidth: 1.6625
  })));
}
export default SvgLabel;